import { NavLink } from "react-router-dom";

/** Small internal nav between the two Members-section pages — kept as a
 * plain NavLink pair rather than a third top-level sidebar entry (see
 * src/App.tsx's single "Members" nav item). */
export function MembersNav() {
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `rounded-md px-3 py-1.5 text-sm font-medium ${
      isActive ? "bg-brass/15 text-brass" : "text-text-secondary hover:bg-bg-hover"
    }`;

  return (
    <nav className="mb-4 flex gap-2" aria-label="Members section">
      <NavLink to="/members" end className={linkClass}>
        Members
      </NavLink>
      <NavLink to="/members/studio" className={linkClass} data-testid="studio-nav-link">
        Studio day grid
      </NavLink>
    </nav>
  );
}
